@if (isInline() || (isSub() && openSubmenusInline())) {
  <ul
    role="menu"
    class="ms-2 block"
    [ngClass]="{ hidden: !opened() }"
    (keydown)="handleKeydown($event)"
    (focusout)="handleFocusout($event)"
  >
    <ng-container [ngTemplateOutlet]="innerMegamenu"></ng-container>
  </ul>
} @else {
  <div
    role="menu"
    [attr.aria-hidden]="!opened()"
    class="animate-transition absolute z-10 flex pr-9 pl-9 transition-[opacity,translate] duration-200 ease-in-out"
    [class.opacity-0]="!opened()"
    [class.-translate-y-2]="!opened()"
    [class.invisible]="!opened()"
    [class.max-h-0]="!opened()"
    [class.overflow-hidden]="!opened()"
    [class.pointer-events-none]="!opened()"
    [class.opacity-100]="opened()"
    [class.translate-y-0]="opened()"
    [class.visible]="opened()"
    [class.pointer-events-auto]="opened()"
    [ngClass]="[menuClasses()]"
    [ngStyle]="{
      top: topPositionStyle(),
      left: 0
    }"
    (keydown)="handleKeydown($event)"
    (focusout)="handleFocusout($event)"
  >
    @if (hoverBridgeHeight() > 0) {
      <!-- Invisible strip over the gap up to the trigger: hovering it keeps the trigger hovered, so the menu stays open.
           The megamenu sits at left 0, so the trigger offset applies as is. -->
      <div
        aria-hidden="true"
        class="absolute bottom-full"
        [style.left.px]="initialPositionLeft()"
        [style.width.px]="hoverBridgeWidth()"
        [style.height.px]="hoverBridgeHeight()"
      ></div>
    }
    <ng-container [ngTemplateOutlet]="innerMegamenu"></ng-container>
  </div>
}

<ng-template #innerMegamenu>
  <div class="flex w-full flex-wrap">
    @for (item of items(); track trackMegaMenu(item)) {
      @let active = isItemActive(item);
      <div class="xxl:w-1/5 mb-4 w-full justify-start pr-4 lg:w-1/2 xl:w-1/4">
        @if (item.linkUrl) {
          @let isExternalUrl = item.linkUrl?.startsWith('http');
          <a
            role="menuitem"
            [href]="item.linkUrl"
            [target]="isExternalUrl ? '_blank' : (item.linkTarget ?? '_self')"
            [attr.rel]="isExternalUrl ? 'noopener noreferrer' : null"
            [attr.tabindex]="opened() ? 0 : -1"
            [attr.aria-current]="active ? 'page' : null"
            [class]="
              'text-primary-main focus-visible:ring-primary-main flex w-full items-center justify-between py-3 pr-6 text-left text-base font-bold focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2' +
              ' ' +
              menuItemClasses()
            "
            [ngClass]="[hoverMenuItemClasses(), itemColorClasses(active), active && activeUnderlined() ? 'underline' : '']"
            (mouseenter)="mouseentered(item)"
          >
            @if (showItemGlyphs() && item.glyph) {
              <gs-icon [iconName]="item.glyph" iconWeight="light" [attr.aria-hidden]="true" class="mr-2"></gs-icon>
            }
            {{ item.label }}
          </a>
        } @else {
          <span
            role="menuitem"
            [attr.aria-disabled]="true"
            [attr.tabindex]="-1"
            [class]="
              'text-primary-main flex w-full cursor-not-allowed items-center justify-between py-3 pr-6 text-left text-base font-bold opacity-60' +
              ' ' +
              menuItemClasses()
            "
            [ngClass]="[menuItemColorClasses()]"
          >
            @if (showItemGlyphs() && item.glyph) {
              <gs-icon [iconName]="item.glyph" iconWeight="light" [attr.aria-hidden]="true" class="mr-2"></gs-icon>
            }
            {{ item.label }}
          </span>
        }
        @if (item.items.length > 0) {
          @for (subItem of item.items; track trackMegaMenu(subItem)) {
            @let subActive = isItemActive(subItem);
            @if (subItem.linkUrl) {
              @let isExternalSubUrl = subItem.linkUrl?.startsWith('http');
              <a
                role="menuitem"
                [href]="subItem.linkUrl"
                [target]="isExternalSubUrl ? '_blank' : (subItem.linkTarget ?? '_self')"
                [attr.rel]="isExternalSubUrl ? 'noopener noreferrer' : null"
                [attr.tabindex]="opened() ? 0 : -1"
                [attr.aria-current]="subActive ? 'page' : null"
                [class]="
                  'focus-visible:ring-primary-main flex w-full items-center py-1 text-left text-base font-light focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2' +
                  ' ' +
                  menuItemClasses()
                "
                [ngClass]="[hoverMenuItemClasses(), itemColorClasses(subActive), subActive && activeUnderlined() ? 'underline' : '']"
                (mouseenter)="mouseentered(subItem)"
              >
                @if (showItemPhotos() && subItem.photo) {
                  <gs-optimized-image
                    [photo]="subItem.photo"
                    size="small"
                    mode="fill"
                    sizes="48px"
                    [alt]="subItem.photo.alt ?? subItem.photo.title ?? subItem.label"
                    containerClass="mr-3 size-12 shrink-0 rounded-lg"
                    objectFit="object-cover"
                  />
                }
                {{ subItem.label }}
              </a>
            } @else {
              <span
                role="menuitem"
                [attr.aria-disabled]="true"
                [attr.tabindex]="-1"
                [class]="
                  'flex w-full cursor-not-allowed items-center py-1 text-left text-base font-light opacity-60' + ' ' + menuItemClasses()
                "
                [ngClass]="[menuItemColorClasses()]"
              >
                @if (showItemPhotos() && subItem.photo) {
                  <gs-optimized-image
                    [photo]="subItem.photo"
                    size="small"
                    mode="fill"
                    sizes="48px"
                    [alt]="subItem.photo.alt ?? subItem.photo.title ?? subItem.label"
                    containerClass="mr-3 size-12 shrink-0 rounded-lg"
                    objectFit="object-cover"
                  />
                }
                {{ subItem.label }}
              </span>
            }
          }
        }
      </div>
    }
  </div>
  <div></div>
</ng-template>
